import { render, staticRenderFns } from "./PreviousOrders.vue?vue&type=template&id=52255ca9"
import script from "./PreviousOrders.vue?vue&type=script&lang=js"
export * from "./PreviousOrders.vue?vue&type=script&lang=js"
import style0 from "./PreviousOrders.vue?vue&type=style&index=0&id=52255ca9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports